import Marquee from "react-fast-marquee";

const words = ["Free to join", "Hand-picked bottles", "Skip anytime", "No club fees", "Shipped nationwide", "Swap or cancel freely"];

export const EditorialMarquee = () => (
  <div className="border-y border-ink/10 bg-[#F1EADD] py-6" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {words.map((w) => (
        <span key={w} className="mx-14 flex items-center gap-28 font-serif text-2xl italic text-ink/80 md:text-3xl">
          {w}
          <span className="ml-28 h-1.5 w-1.5 rounded-full bg-wine/60" />
        </span>
      ))}
    </Marquee>
  </div>
);
